export const dashboard = {
  // Dashboard main
  "dashboard.title": "Tableau de bord",
  "dashboard.welcome": "Bienvenue",
  "dashboard.overview": "Aperçu",
  
  // Stats cards
  "stats.total_views": "Vues totales",
  "stats.total_contacts": "Contacts totaux",
  "stats.total_reviews": "Avis totaux",
  "stats.avg_rating": "Note moyenne",
  "stats.total_products": "Produits totaux",
  "stats.active_products": "Produits actifs",
  "stats.monthly_revenue": "Revenus mensuels",
  
  // Navigation tabs
  "tab.overview": "Aperçu",
  "tab.profile": "Profil",
  "tab.products": "Produits",
  "tab.reviews": "Avis",
  "tab.analytics": "Analyses",
  "tab.subscription": "Abonnement",
  "tab.settings": "Paramètres",
  "tab.team": "Équipe",
  "tab.purchase_requests": "Demandes d'achat",
  "tab.messages": "Messages",
  "tab.galerie": "Galerie",
  "tab.verification": "Vérification",
  
  // Profile section
  "profile.title": "Informations du profil",
  "profile.business_name": "Nom de l'entreprise",
  "profile.description": "Description",
  "profile.category": "Catégorie",
  "profile.phone": "Téléphone",
  "profile.email": "Email",
  "profile.website": "Site web",
  "profile.address": "Adresse",
  "profile.city": "Ville",
  "profile.state": "État",
  "profile.business_hours": "Heures d'ouverture",
  "profile.update": "Mettre à jour le profil",
  
  // Products section
  "products.title": "Gestion des produits",
  "products.add": "Ajouter un produit",
  "products.edit": "Modifier le produit",
  "products.delete": "Supprimer le produit",
  "products.name": "Nom du produit",
  "products.price": "Prix",
  "products.stock": "Stock",
  "products.category": "Catégorie",
  "products.description": "Description",
  "products.images": "Images",
  "products.image": "Image",
  "products.status": "Statut",
  "products.in_development": "Fonctionnalité en cours de développement",
  
  // Subscription section
  "subscription.title": "Plan d'abonnement",
  "subscription.current_plan": "Plan actuel",
  "subscription.upgrade": "Mettre à niveau",
  "subscription.features": "Fonctionnalités",
  "subscription.billing": "Facturation",
  "subscription.expires": "Expire le {{date}}",
  "subscription.select_plan": "Choisir ce plan",
  "subscription.current_badge": "Plan actuel",
  "subscription.plan_free_price": "Gratuit",
  "subscription.plan_basic_price": "25 000 XOF / 30 jours",
  "subscription.plan_premium_price": "200 000 XOF / 365 jours",
  "subscription.premium_includes_featured": "Vitrine incluse",
  "subscription.featured_title": "Vitrine",
  "subscription.featured_desc": "Votre profil apparaît en tête des résultats et des catégories pendant 30 jours.",
  "subscription.featured_price": "50 000 XOF / 30 jours",
  "subscription.featured_cta": "Activer la Vitrine",
  "subscription.featured_active": "Vitrine active jusqu'au {{date}}",
  
  // Plans
  "plan.free": "Gratuit",
  "plan.basic": "Basic",
  "plan.premium": "Premium",
  "plan.free_desc": "Parfait pour commencer",
  "plan.basic_desc": "Pour les petites entreprises",
  "plan.premium_desc": "Pour les grandes entreprises",
  
  // Plan features
  "plan.free_max_products": "5 produits max",
  "plan.basic_max_products": "50 produits",
  "plan.unlimited_products": "Produits illimités",
  "plan.basic_support": "Support de base",
  "plan.priority_support": "Support prioritaire",
  "plan.support_247": "Support 24/7",
  "plan.simple_profile": "Profil simple",
  "plan.basic_analytics": "Analyses de base",
  "plan.advanced_analytics": "Analyses avancées",
  "plan.verified_badge": "Badge vérifié",
  "plan.priority_promotion": "Promotion prioritaire",
  
  // Features
  "feature.products_limit": "produits maximum",
  "feature.photos_limit": "photos par produit",
  "feature.analytics": "Analyses avancées",
  "feature.priority_support": "Support prioritaire",
  "feature.custom_domain": "Domaine personnalisé",
  "feature.unlimited": "Illimité",

  // Gallery section
  "gallery.title": "Gestion de la galerie",
  "gallery.subtitle": "Gérez vos photos pour présenter vos services aux clients.",
  "gallery.edit": "Modifier",
  "gallery.cancel": "Annuler",
  "gallery.save": "Enregistrer",
  "gallery.saving": "Enregistrement...",
  "gallery.photo_limit": "Photos: {{count}} / {{max}} (limite abonnement {{plan}})",
  "gallery.add_image_url": "Ajouter une image URL",
  "gallery.placeholder_url": "https://example.com/image.jpg",
  "gallery.add": "Ajouter",
  "gallery.no_photos": "Aucune photo dans votre galerie",
  "gallery.add_photos": "Ajouter des photos",

  // Upgrade messages
  "dashboard.my_business": "Mon entreprise",
  "dashboard.toggle_sidebar": "Basculer le menu",
  "dashboard.expand_sidebar": "Développer le menu",
  "dashboard.collapse_sidebar": "Réduire le menu",
  "dashboard.start_tour": "Démarrer la visite guidée",
  "dashboard.manage_business": "Gérez votre entreprise et vos informations",
  "dashboard.orders": "Commandes",
  "dashboard.monthly_revenue": "Revenus mensuels",
  "dashboard.save_error": "Erreur lors de la sauvegarde",
  "dashboard.delete_product": "Supprimer le produit",
  "dashboard.delete_product_confirm": "Êtes-vous sûr de vouloir supprimer \"{{name}}\" ? Cette action est irréversible.",
  "dashboard.delete_review": "Supprimer l'avis",
  "dashboard.delete_review_confirm": "Êtes-vous sûr de vouloir supprimer l'avis de {{name}} ?",
  "dashboard.client": "Client",
  "dashboard.gallery": "Galerie",
  "dashboard.reviews": "Avis",
  "dashboard.verification": "Vérification",
  "dashboard.analytics": "Analytics",
  "dashboard.subscription": "Abonnement",
  "dashboard.team": "Équipe",
  "dashboard.purchase_requests": "Demandes d'achat",
  "dashboard.my_purchase_requests": "Mes demandes d'achat",
  "dashboard.manage_purchase_requests_desc": "Suivez vos demandes d'achat et les devis reçus des fournisseurs.",
  "dashboard.no_purchase_requests": "Vous n'avez pas encore de demande d'achat",
  "dashboard.create_request_from_home": "Publiez une demande depuis la page « Demande d'achat » pour recevoir des offres de fournisseurs.",
  "dashboard.confirm_delete": "Confirmer la suppression ?",
  "dashboard.business_profile": "Profil de l'entreprise",

  // Error messages
  "dashboard.errors.add_product": "Erreur inconnue lors de l'ajout du produit",
  "dashboard.errors.update_product": "Erreur inconnue lors de la mise à jour du produit",
  "dashboard.errors.delete_product": "Erreur inconnue lors de la suppression du produit",
  "dashboard.errors.update_review": "Erreur lors de la mise à jour de l'avis",
  "dashboard.errors.delete_review": "Erreur lors de la suppression de l'avis",

  // Success messages
  "dashboard.success.review_updated": "Avis mis à jour",
  "dashboard.success.review_deleted": "Avis supprimé",

  // Coming soon messages
  "dashboard.coming_soon.title": "Fonctionnalité en cours de développement",
  "dashboard.coming_soon.message": "Cette fonctionnalité n'est pas encore disponible mais sera bientôt mise en ligne.",
  "dashboard.coming_soon.analytics": "Les analyses avancées seront bientôt disponibles.",
  "dashboard.coming_soon.team": "La gestion d'équipe sera bientôt disponible.",
  "dashboard.coming_soon.subscription": "La gestion des abonnements sera bientôt disponible.",
  
  // Tour messages
  "dashboard.tour.skip": "Passer",
  "dashboard.tour.previous": "Précédent",
  "dashboard.tour.next": "Suivant",
  "dashboard.tour.finish": "Terminer",
  "dashboard.tour.welcome.title": "Bienvenue dans votre tableau de bord",
  "dashboard.tour.welcome.content": "Découvrez les fonctionnalités de votre tableau de bord pour gérer votre entreprise.",
  "dashboard.tour.sidebar.title": "Navigation",
  "dashboard.tour.sidebar.content": "Utilisez le menu latéral pour accéder aux différentes sections de votre tableau de bord.",
  "dashboard.tour.overview.title": "Aperçu",
  "dashboard.tour.overview.content": "Consultez les statistiques clés de votre entreprise en un coup d'œil.",
  "dashboard.tour.profile.title": "Profil",
  "dashboard.tour.profile.content": "Gérez les informations de votre entreprise et vos coordonnées.",
  "dashboard.tour.products.title": "Produits",
  "dashboard.tour.products.content": "Ajoutez, modifiez ou supprimez vos produits et services.",
  "dashboard.tour.reviews.title": "Avis",
  "dashboard.tour.reviews.content": "Consultez et répondez aux avis de vos clients.",
  "dashboard.tour.analytics.title": "Analytics",
  "dashboard.tour.analytics.content": "Analysez les performances de votre entreprise avec des graphiques détaillés.",
  "dashboard.tour.subscription.title": "Abonnement",
  "dashboard.tour.subscription.content": "Gérez votre abonnement et découvrez les fonctionnalités premium.",
  "dashboard.tour.settings.title": "Paramètres",
  "dashboard.tour.settings.content": "Configurez les paramètres de votre compte et de votre entreprise.",
  "dashboard.tour.team.title": "Équipe",
  "dashboard.tour.team.content": "Gérez les membres de votre équipe et leurs permissions.",
  "dashboard.tour.notifications.title": "Notifications",
  "dashboard.tour.notifications.content": "Restez informé des activités importantes de votre entreprise.",
  "dashboard.tour.complete.title": "Visite guidée terminée",
  // Loading and messages
  "loading.title": "Chargement du tableau de bord...",
  "loading.timeout_title": "Le chargement prend plus de temps que prévu",
  "loading.timeout_message": "Veuillez patienter ou réessayer. Si le problème persiste, vérifiez votre connexion internet.",
  "loading.retry": "Réessayer",

  // Actions
  "action.edit": "Modifier",
  "action.cancel": "Annuler",
  "action.save": "Enregistrer",
  "action.delete": "Supprimer",
  "action.add": "Ajouter",
  "action.close": "Fermer",

  // Status
  "status.active": "Actif",
  "status.inactive": "Inactif",
  "status.pending": "En attente",

};

export default dashboard;